import { z } from 'zod';
import { WorkflowWriteBackMode } from 'libs/end-to-end/src/types/databases/workflows/workflow-write-back-mode';
import { WriteBackToFountainStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/fountain-write-back';
import { WriteBackToLeverStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/lever-write-back';
import { WriteBackToGreenhouseStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/greenhouse-write-back';
import { WriteBackToWorkdayViaWsStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/workday-write-back';
import { WriteBackToAdpStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/adp-write-back';

export const WorkflowHiringReadinessExplanationWriteBackStrategy = z.union([
  WriteBackToGreenhouseStrategy,
  WriteBackToFountainStrategy,
  WriteBackToLeverStrategy,
  WriteBackToWorkdayViaWsStrategy,
  WriteBackToAdpStrategy,
]);

export type WorkflowHiringReadinessExplanationWriteBackStrategy = z.infer<
  typeof WorkflowHiringReadinessExplanationWriteBackStrategy
>;

/**
 * Details for a workflow that writes back hiring readiness explanation.
 */
export const WorkflowHiringReadinessExplanationWriteBackDetails = z.object({
  type: z.literal('hiringReadinessExplanationWriteBack'),

  /**
   * The strategy for writing back.
   */
  strategy: WorkflowHiringReadinessExplanationWriteBackStrategy.optional(),

  /**
   * The mode for writing back.
   */
  mode: WorkflowWriteBackMode.optional(),

  /**
   * The number of previous days of applicants to consider for writing back.
   */
  numPreviousDaysOfApplicants: z.number().optional(),

  /**
   * The minimum readiness rating for an applicant to be considered for writing back.
   */
  minReadinessRating: z.number().optional(),

  /**
   * Number of samples to send
   */
  numberOfSamplesToSend: z.number().optional(),
  /**
   * The format for the explanation text.
   */
  format: z.enum(['long', 'short']).optional(),
});

export type WorkflowHiringReadinessExplanationWriteBackDetails = z.infer<
  typeof WorkflowHiringReadinessExplanationWriteBackDetails
>;
